<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col :lg="14" :sm="24" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><b>职位发布</b></span>
            <el-button
              icon="el-icon-circle-close"
              type="warning"
              style="float: right; margin-left: 10px"
              @click="clearTemplate"
              >清空重置</el-button
            >
            <zr-combobox
              v-model="template"
              :data-array="templateArray"
              value-field="id"
              label-field="tempName"
              style="float: right; width: 170px"
              filterable
              clearable
              placeholder="选择模板(输入搜索)"
              @change="templateChange"
            ></zr-combobox>
          </div>
          <el-form ref="postForm" :model="form" :rules="rules">
            <el-form-item label="职位类别:" prop="postType" required>
              <zr-combobox
                v-model="form.postType"
                :data-array="postTypeArray"
                value-field="code"
                label-field="name"
              ></zr-combobox>
            </el-form-item>
            <el-form-item label="职位名称:" prop="name" required>
              <el-col :span="16">
                <el-input
                  v-model="form.name"
                  placeholder="职位名称"
                  clearable
                ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="职位编码:" prop="postCode" required>
              <el-col :span="16">
                <el-input
                    v-model="form.postCode"
                    placeholder="职位编码"
                    clearable
                ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="学科类别:" prop="science" required>
              <el-col :span="16"
                >
<!--                <zr-combobox-->
<!--                  v-model="form.science"-->
<!--                  class="multipleSelect"-->
<!--                  :data-array="scienceTypeArray"-->
<!--                  multiple-->
<!--                  value-field="code"-->
<!--                  label-field="name"-->
<!--                ></zr-combobox-->
<!--              >-->
                <SearchSelects
                    v-model="form.science"
                    :options="scienceTypeArray"
                    placeholder="请选择学科"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="学历要求:" prop="eduRequire" required>
              <zr-combobox
                v-model="form.eduRequire"
                :data-array="eduTypeArray"
                style="width: 120px"
                value-field="code"
                label-field="name"
              ></zr-combobox>
              <el-checkbox
                v-model="form.eduRequireAndOver"
                style="margin-left: 10px"
                >及以上</el-checkbox
              >
            </el-form-item>
            <el-form-item label="专业要求:" prop="careerRequire" required>
              <el-col :span="16"
                ><el-input
                  v-model="form.careerRequire"
                  placeholder="专业要求"
                  clearable
                ></el-input
              ></el-col>
            </el-form-item>
            <el-form-item label="科研方向:" prop="researchOrientations" required>
              <el-col :span="16">
                <research-dialog
                    v-model="form.researchOrientations"
                >
                </research-dialog>
              </el-col>
            </el-form-item>
            <el-form-item label="截止日期:" prop="endDate" required>
              <el-date-picker
                v-model="form.endDate"
                align="right"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择截止日期"
                @change="dateChange"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="招聘人数:" prop="requireNum">
              <el-input-number
                v-model="form.requireNum"
                placeholder="不填则为不限"
                size="medium"
                :min="0"
                :precision="0"
                :step="1"
                style="width: 180px"
                clearable
              ></el-input-number
              >&nbsp;人（0为不限）
            </el-form-item>
            <el-form-item label="工作地点:" prop="workAddress">
              <el-cascader
                v-model="form.workAddress"
                expand-trigger="hover"
                :options="workAddressArray"
                clearable
                :props="{
                  value: 'code',
                  label: 'name',
                  children: 'children',
                }"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="工作年限:" prop="workYear">
              <el-input-number
                v-model="form.workYear"
                size="medium"
                :min="0"
                :precision="0"
                :step="1"
                style="width: 120px"
              ></el-input-number>
              年<el-checkbox
                v-model="form.workYearAndOver"
                style="margin-left: 10px"
                >及以上</el-checkbox
              >
            </el-form-item>
            <el-form-item label="职位描述:" prop="remark">
              <el-col :span="21">
                <el-input
                  v-model="form.remark"
                  clearable
                  type="textarea"
                  maxlength="800"
                  show-word-limit
                  :rows="5"
                  :autosize="{ minRows: 5, maxRows: 15 }"
                  placeholder="职位描述"
                ></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="首页排序:" prop="sort">
              <el-input-number
                v-model="form.sort"
                size="mini"
                :min="0"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item v-if="isFilter" label="是否事编:" prop="property">
              <zr-combobox
                v-model="form.property"
                placeholder="是否事编"
                clearable
                :data-array="[
                  { name: '是', code: '1' },
                  { name: '否', code: '0' },
                ]"
                value-field="code"
                label-field="name"
              ></zr-combobox>
            </el-form-item>
          </el-form>
          <el-divider />
          <slot name="footBtn" :form="form">
            <el-button
              icon="el-icon-circle-close"
              type="info"
              style="float: right"
              @click="preview"
              >职位预览</el-button
            >
            <el-popover
              v-model="popVisible"
              placement="top"
              width="400"
              trigger="click"
            >
              <div>
                <el-row>
                  <el-input
                    v-model="newTemplateName"
                    placeholder="请填写模板名称"
                    maxlength="30"
                    clearable
                  ></el-input>
                </el-row>
                <el-row style="margin-top: 10px">
                  <el-button
                    icon="el-icon-circle-check"
                    type="success"
                    style="float: right"
                    @click="saveAsModle"
                    >确定</el-button
                  >
                  <el-button
                    icon="el-icon-circle-close"
                    style="float: right"
                    @click="popVisible = false"
                    >取消</el-button
                  >
                </el-row>
              </div>
              <el-button
                slot="reference"
                icon="el-icon-circle-plus-outline"
                type="success"
                style="float: right"
                >保存为模板</el-button
              >
            </el-popover>
            <el-button
              icon="el-icon-circle-check"
              type="primary"
              style="float: right"
              @click="publish"
              >发布职位</el-button
            >
          </slot>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getTemplate,
  savePostInfo,
  saveTemplate,
  getBasicData,
  searchPostInfoById,
} from "@/api/job/postInfo";
import { mapGetters } from "vuex";
import { getDepartmentByDeptCode } from "@api/recruit/hr/recruitInfo";
import treeHelper from "../../../../mock/utils/treeHelper";
import { messageDuration } from "../../../config/settings";
import researchDialog from "^/zr/dialog/researchDialog.vue";
import SelectTree from "@/views/recruit/applicant/selectTree.vue";
import SearchSelects from "^/zr/dialog/searchSelects.vue";

export default {
  name: "PostInfoEdit",
  components: {SelectTree, researchDialog,SearchSelects },
  data() {
    return {
      form: {
        postType: "",
        name: "",
        science: [],
        eduRequire: "",
        careerRequire: "",
        requireNum: 0,
        workAddress: [],
        workYear: 0,
        remark: "",
        eduRequireAndOver: false,
        workYearAndOver: false,
        isFilter: true, // 是否显示是否事编字段
      },
      rules: {
        postType: [
          { required: true, message: "请输入职位类别", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入职位名称", trigger: "blur" }],
        science: [
          { required: true, message: "请输入学科类别", trigger: "blur" },
        ],
        eduRequire: [
          { required: true, message: "请输入学历要求", trigger: "blur" },
        ],
        careerRequire: [
          { required: true, message: "请输入专业要求", trigger: "blur" },
        ],
        endDate: [
          { required: true, message: "请输入截止日期", trigger: "blur" },
        ],
      },
      templateArray: [],
      template: "",
      newTemplateName: "", // 新增模板名字
      popVisible: false,
      postTypeArray: [],
      eduTypeArray: [],
      scienceTypeArray: [],
      workAddressArray: [],
      deptInfo: "", // 登录人部门介绍
    };
  },
  computed: {
    ...mapGetters({
      deptCode: "user/deptCode",
    }),
  },
  async created() {
    await this.loadDeptInfo();
    await this.getTemplateArray();
    await this.getPostTypeArray();
    await this.getEduTypeArray();
    await this.getScienceTypeArray();
    await this.getWorkAddressArray();
  },
  beforeMount() {},
  async mounted() {
    if (this.$route.query.formData) {
      // 预览后返回
      this.form = JSON.parse(this.$route.query.formData.toString());
    } else if (this.$route.query.positionInfoId) {
      // 修改职位时,查询数据
      await this.getFormData(this.$route.query.positionInfoId);
      // 如果是复制，则删除id
      if (this.$route.query.copy) {
        this.form.id = null;
        this.form.viewCount=0
      }
    } /*else {
      this.clearTemplate();
    }*/
  },
  methods: {
    // 传参数为当前登录用户的deptCode
    async loadDeptInfo() {
      let res = await getDepartmentByDeptCode({ deptCode: this.deptCode });
      if (res.success) {
        this.deptInfo = res.data.remark;
        // 是否过滤的参数
        if (res.data.isCorporation == "1") {
          this.isFilter = true;
        } else {
          this.isFilter = false;
        }
      } else {
        this.$message.error(res.message);
      }
    },
    // 查询表单数据
    async getFormData(positionInfoId) {
      let res = await searchPostInfoById({
        positionInfoId: positionInfoId,
      });
      if (res.success) {
        if (res.data.eduRequireAndOver) {
          res.data.eduRequireAndOver = true;
        } else {
          res.data.eduRequireAndOver = false;
        }
        if (res.data.workYearAndOver) {
          res.data.workYearAndOver = true;
        } else {
          res.data.workYearAndOver = false;
        }
        this.form = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 模板列表
    async getTemplateArray() {
      let res = await getTemplate();
      if (res.success) {
        this.templateArray = JSON.parse(res.data);
      } else {
        this.$message.error(res.message);
      }
    },
    //职位类别
    async getPostTypeArray() {
      let res = await getBasicData({ typeCode: "postType" });
      if (res.success) {
        this.postTypeArray = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //学历要求
    async getEduTypeArray() {
      let res = await getBasicData({ typeCode: "eduRequire" });
      if (res.success) {
        this.eduTypeArray = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //学科类别
    async getScienceTypeArray() {
      let res = await getBasicData({ typeCode: "scienceType" });
      if (res.success) {
        this.scienceTypeArray = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //工作地点
    async getWorkAddressArray() {
      let res = await getBasicData({ typeCode: "workPlace" });
      if (res.success) {
        this.workAddressArray = treeHelper.generateTreeSmart(
          res.data,
          "parentId",
          "id"
        );
        this.removeEmptyChildren(this.workAddressArray);
      } else {
        this.$message.error(res.message);
      }
    },
    // 删除树中节点的children为空的节点的children
    removeEmptyChildren(node) {
      node.forEach((item) => {
        if ("children" in item && item.children.length === 0) {
          delete item.children;
        } else if ("children" in item && item.children.length) {
          this.removeEmptyChildren(item.children);
        }
      });
    },
    dateChange(value) {
      this.form.endDate = value;
    },
    // 模板选择
    async templateChange(id) {
      let postInfoId = "";
      for (let i in this.templateArray) {
        if (id == this.templateArray[i].id)
          postInfoId = this.templateArray[i].postInfoId;
      }
      if (postInfoId) {
        let res = await searchPostInfoById({
          positionInfoId: postInfoId,
        });
        if (res.success) {
          // if (this.form.id) {
          //   let id = this.form.id;
          //   this.form = res.data;
          //   this.form.id = id;
          // } else {
          //   res.data.id = "";
          //   this.form = res.data;
          // }
          this.form.postType = res.data.postType;
          this.form.name = res.data.name;
          this.form.science = res.data.science;
          this.form.eduRequire = res.data.eduRequire;
          this.form.eduRequireAndOver =
            res.data.eduRequireAndOver == 1 ? true : false;
          this.form.careerRequire = res.data.careerRequire;
          this.form.workYear = res.data.workYear;
          this.form.workYearAndOver =
            res.data.workYearAndOver == 1 ? true : false;
          this.form.workAddress = res.data.workAddress;
          this.form.requireNum = res.data.requireNum;
          this.form.remark = res.data.remark;
        } else {
          this.$message.error(res.message);
        }
      }
    },
    clearTemplate() {
      this.$refs.postForm.resetFields();
      this.template = "";
      this.form = {
        workYear: 0,
        eduRequireAndOver: false,
        workYearAndOver: false,
        science: [],
      };
    },
    // 发布职位
    publish() {
      this.$refs.postForm.validate((valid) => {
        if (!valid) return;
        if(this.form.researchOrientations&&(this.form.researchOrientations===""||this.form.researchOrientations.includes(",,")||this.form.researchOrientations[this.form.researchOrientations.length-1]===",")){
          this.$message.error("科研方向存在未填写内容！")
          return;
        }
        if (this.form.eduRequireAndOver) {
          this.form.eduRequireAndOver = 1;
        } else {
          this.form.eduRequireAndOver = 0;
        }
        if (this.form.workYearAndOver) {
          this.form.workYearAndOver = 1;
        } else {
          this.form.workYearAndOver = 0;
        }
        savePostInfo({
          formData: JSON.stringify(this.form),
          deptInfo: JSON.stringify(this.deptInfo),
        }).then((res) => {
          if (res.success) {
            if (res.data.eduRequireAndOver) {
              res.data.eduRequireAndOver = true;
            } else {
              res.data.eduRequireAndOver = false;
            }
            if (res.data.workYearAndOver) {
              res.data.workYearAndOver = true;
            } else {
              res.data.workYearAndOver = false;
            }
            this.form = res.data;
            this.$message.success({
              message: "发布成功",
              duration: messageDuration,
            });
            this.$router.push({
              path: "/positionManagement/index",
            });
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 保存模板
    saveAsModle() {
      this.$refs.postForm.validate((valid) => {
        if (!valid) return;
        if(this.form.researchOrientations&&(this.form.researchOrientations===""||this.form.researchOrientations.includes(",,")||this.form.researchOrientations[this.form.researchOrientations.length-1]===",")){
          this.$message.error("科研方向存在未填写内容！")
          return;
        }
        if (this.newTemplateName.length > 0) {
          if (this.form.eduRequireAndOver) {
            this.form.eduRequireAndOver = 1;
          } else {
            this.form.eduRequireAndOver = 0;
          }
          if (this.form.workYearAndOver) {
            this.form.workYearAndOver = 1;
          } else {
            this.form.workYearAndOver = 0;
          }
          savePostInfo({
            formData: JSON.stringify(this.form),
            deptInfo: JSON.stringify(this.deptInfo),
          }).then((res) => {
            if (res.success) {
              this.$message.success({
                message: "发布成功",
                duration: messageDuration,
              });
              if (res.data.eduRequireAndOver) {
                res.data.eduRequireAndOver = true;
              } else {
                res.data.eduRequireAndOver = false;
              }
              if (res.data.workYearAndOver) {
                res.data.workYearAndOver = true;
              } else {
                res.data.workYearAndOver = false;
              }
              this.form = res.data;
              // 保存模板
              saveTemplate({
                postInfoId: this.form.id,
                tempName: this.newTemplateName,
              }).then((res1) => {
                if (res1.success) {
                  this.$message.success({
                    message: "模板保存成功",
                    duration: messageDuration,
                  });
                  this.getTemplateArray();
                } else {
                  this.$message.error(res1.message);
                }
              });
            } else {
              this.$message.error(res.message);
            }
          });
          this.popVisible = false;
        } else {
          this.$message.warning("请先填写模板名称!");
        }
      });
    },
    // 职位预览
    preview() {
      this.$refs.postForm.validate((valid) => {
        if (!valid) return;
        this.$router.push({
          path: "/positionView/index",
          query: {
            formData: JSON.stringify(this.form),
            postTypeArray: this.postTypeArray,
            eduTypeArray: this.eduTypeArray,
            scienceTypeArray: this.scienceTypeArray,
            workAddressArray: this.workAddressArray,
          },
        });
      });
    },
  },
};
</script>

<style scoped>
.multipleSelect {
  width: 100%;
}
.el-button {
  margin-left: 10px;
  margin-bottom: 10px;
}
>>> .el-form-item__label {
  width: 85px;
}
</style>
